import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate, setLocale } from 'react-redux-i18n'
import { store } from '../../../../../app/store'
import { languages } from '../../../../../configs/language'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { resetStoreSelectCurrencyUnitExceptExchangeRates } from '../../../../common/selectCurrencyUnit/slice'
import { SelectCustom } from '../../../../common/selectCustom'
import EventEmitter, {
  DOWNLOAD_PDF,
  END_PROCESS_DOWNLOAD_PDF,
} from '../../../../helpers/EventEmitter'
import { saveLanguage } from '../../../../helpers/language'
import { selectCurrency } from '../../../../userManagement/settingPreferences/store/slice'
import { Z_INDEX } from '../../../../utils/common'
import { CURRENCY, CURRENCY_UNIT, UNIT } from '../../../../utils/currency'
import { TYPE_DOWNLOAD } from '../../constant'
import { isFs } from '../../helper'
import { convertItemsPdf } from './helper'
import classes from './index.module.scss'
import {
  addCurrencyUnitFs,
  changeCurrencyUnitFs,
  removeCurrencyUnitFs,
  selectCurrencyUnitFs,
  selectIsHasCompanyName,
  selectIsHasPortName,
  selectIsHasReportSubtitle,
  selectPanelById,
  selectPanelId,
  selectReportSubtitle,
  selectReportTitle,
} from './store/slice'

export const languagesSelect = [
  { value: languages.en, label: 'dynamicReport.EN', isI18n: true },
  { value: languages.vi, label: 'dynamicReport.VI', isI18n: true },
]

const PopupSettingReport = ({
  localePdf,
  isShowPopup,
  typeDownload,
  localeSystem,
  setLocalePdf,
  setIsShowPopup,
}) => {
  const dispatch = useDispatch()

  const currencyUnitFs = useSelector(selectCurrencyUnitFs)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const reportTitle = useSelector(selectReportTitle)
  const isHasReportSubtitle = useSelector(selectIsHasReportSubtitle)
  const reportSubtitle = useSelector(selectReportSubtitle)
  const defaultCurrency = useSelector(selectCurrency)
  const isHasCompanyName = useSelector(selectIsHasCompanyName)
  const isHasPortName = useSelector(selectIsHasPortName)

  const isPreview = typeDownload === TYPE_DOWNLOAD.PREVIEW

  useEffect(() => {
    if (!currencyUnitFs.length) {
      dispatch(
        addCurrencyUnitFs({
          currency: defaultCurrency,
          unit: UNIT.SINGLE.unitKey,
        }),
      )
    }
  }, [currencyUnitFs])

  const submitPdf = () => {
    saveLanguage(localePdf)
    store.dispatch(setLocale(localePdf))
    EventEmitter.dispatch(DOWNLOAD_PDF, {
      items: convertItemsPdf(panelId, panelById),
      typeDownload,
      localeSystem: localeSystem.current,
      reportTitle,
      isHasReportSubtitle,
      reportSubtitle,
      isHasCompanyName,
      isHasPortName,
    })
    closePopup()

    const resetSettingSystem = () => {
      saveLanguage(localeSystem.current)
      store.dispatch(setLocale(localeSystem.current))
      dispatch(resetStoreSelectCurrencyUnitExceptExchangeRates())
      EventEmitter.unsubscribe(END_PROCESS_DOWNLOAD_PDF, resetSettingSystem)
    }
    EventEmitter.subscribe(END_PROCESS_DOWNLOAD_PDF, resetSettingSystem)
  }

  const chooseLanguage = ({ value }) => {
    setLocalePdf(value)
  }

  const closePopup = () => {
    setIsShowPopup(false)
  }

  const addCurrencyUnit = () => {
    dispatch(
      addCurrencyUnitFs({
        currency: defaultCurrency,
        unit: UNIT.SINGLE.unitKey,
      }),
    )
  }

  const removeCurrencyUnit = (index) => () => {
    dispatch(removeCurrencyUnitFs(index))
  }

  const changeCurrencyUnit =
    (index, key, unit) =>
    ({ value }) => {
      if (key === 'currency' && !CURRENCY_UNIT[value].includes(unit)) {
        dispatch(
          changeCurrencyUnitFs({
            index,
            key: 'unit',
            value: UNIT.SINGLE.unitKey,
          }),
        )
      }
      dispatch(changeCurrencyUnitFs({ index, key, value }))
    }

  const isHasFs = panelId.some((id) => isFs(panelById[id].screen))

  return (
    <PopupAction
      appendStyle={{
        padding: '20px',
        backgroundColor: '#F3F3F3',
        width: 700,
        borderRadius: '4px',
      }}
      isShow={isShowPopup}
      title={
        isPreview
          ? 'dynamicReport.TITLE_PREVIEW'
          : 'dynamicReport.TITLE_DOWNLOAD'
      }
      btnCancel={{
        label: 'common.CANCEL',
        isI18n: true,
        event: closePopup,
      }}
      btnSubmit={{
        label: isPreview
          ? 'dynamicReport.PREVIEW'
          : 'dynamicReport.SUBMIT_EXPORT',
        isI18n: true,
        event: submitPdf,
      }}
      handleClose={closePopup}
    >
      <Element style={{ color: '#3A414B' }}>
        <Translate value="dynamicReport.SELECT_DOWNLOAD" />
        <div className={classes['mr-8']}>
          <ScrollComponent autoHeight autoHeightMax={400}>
            <div className="pr1">
              <div className={`${classes.mt12} dFlex`}>
                <div className="w50 dFlex alignItemsCenter justifyContentBetween">
                  <Translate className="fw600" value="dynamicReport.LANGUAGE" />
                  <div className={classes.selectCurrencyUnit}>
                    <SelectCustom
                      activeItem={{ value: localePdf }}
                      data={languagesSelect}
                      chooseItem={chooseLanguage}
                      zIndex={Z_INDEX.MODAL + 1}
                      isI18n
                    />
                  </div>
                </div>
              </div>
              {currencyUnitFs
                .slice(0, isHasFs ? currencyUnitFs.length : 1)
                .map(({ currency, unit }, index) => {
                  const isLastItem = index === currencyUnitFs.length - 1
                  return (
                    <div key={index} className={`${classes.mt12} dFlex`}>
                      <div className="w50 dFlex alignItemsCenter justifyContentBetween">
                        <Translate
                          className={`fw600 ${classes.maxWidth160}`}
                          value={
                            index
                              ? 'dynamicReport.ADDITIONAL_FS'
                              : 'dynamicReport.CURRENCY'
                          }
                        />
                        <div className={classes.selectCurrencyUnit}>
                          <SelectCustom
                            activeItem={{ value: currency }}
                            data={Object.values(CURRENCY).map((item) => ({
                              label: item,
                              value: item,
                            }))}
                            chooseItem={changeCurrencyUnit(
                              index,
                              'currency',
                              unit,
                            )}
                            zIndex={Z_INDEX.MODAL + 1}
                          />
                        </div>
                      </div>
                      <div
                        className={`w40 pl6 dFlex alignItemsCenter ${classes.unitContainer}`}
                      >
                        <Translate
                          className="fw600"
                          value="dynamicReport.UNIT"
                        />
                        <div className={classes.selectCurrencyUnit}>
                          <SelectCustom
                            activeItem={{ value: unit }}
                            data={CURRENCY_UNIT[currency].map((unitKey) => ({
                              label: UNIT[unitKey].label,
                              value: unitKey,
                              isI18n: true,
                            }))}
                            isI18n
                            chooseItem={changeCurrencyUnit(index, 'unit')}
                            zIndex={Z_INDEX.MODAL + 1}
                          />
                        </div>
                      </div>
                      <div className="w10 dFlex alignItemsCenter justifyContentEnd">
                        {!!index && (
                          <Icon
                            style={{ color: '#9C9C9C', fontSize: 17 }}
                            className="icon-delete-circle-fill"
                            onClick={removeCurrencyUnit(index)}
                          />
                        )}
                        {isHasFs && isLastItem && (
                          <Icon
                            style={{ color: '#2C73E8', fontSize: 17 }}
                            className="icon-plus-circle-fill pl1"
                            onClick={addCurrencyUnit}
                          />
                        )}
                      </div>
                    </div>
                  )
                })}
            </div>
          </ScrollComponent>
        </div>
      </Element>
    </PopupAction>
  )
}

export default PopupSettingReport
